var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 2.75008H16.4163V0.916748H14.583V2.75008H5.41634V0.916748H3.58301V2.75008H2.66634C1.65801 2.75008 0.833008 3.57508 0.833008 4.58341V19.2501C0.833008 20.2584 1.65801 21.0834 2.66634 21.0834H17.333C18.3413 21.0834 19.1663 20.2584 19.1663 19.2501V4.58341C19.1663 3.57508 18.3413 2.75008 17.333 2.75008ZM17.333 19.2501H2.66634V9.16675H17.333V19.2501ZM17.333 7.33341H2.66634V4.58341H17.333V7.33341Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.80f0f31bbc2599266c6e924256261433.svg";
export { ForwardRef as ReactComponent };